import translate from 'angular-translate';
import Sanitize from 'angular-sanitize';

export default angular.module('eventix.common.services.laravelTranslate',[translate, Sanitize])
/**
 * @ngdoc service
 * @name eventix.common.services.LaravelTranslator
 * @requires angular-translate
 * @description
 * A custom language interpolator for angular-translate to parse Laravel translation files
 *
 * https://laravel.com/docs/5.2/localization
 */
    .factory('LaravelTranslator', function($sanitize) {
        return {
            setLocale: function(){},
            getInterpolationIdentifier: function() {
                return 'LaravelTranslator';
            },
            interpolate: function(string, params) {
                if(params && params.count !== undefined) {
                    var simple = false;
                    var pluralisations = _.map(string.split('|'), function(string) {
                    // Match the numerical bounds of a pluralization, i.e.: [0,4] or {9} or [5,Inf]
                        var counts = /^[\{\[](\d+)(?:\,(\d+|Inf))?[\}\]]\s/.exec(string);
                        if(!counts) {
                            simple = true;
                            return string;
                        }
                        return {
                            string: string.replace(counts[0],''),
                            min: parseInt(counts[1],10),
                            max: counts[2] !== undefined ? parseInt(counts[2],10) || Infinity : null
                        };
                    });
                    if(simple) // Catch cases of `singular|plural`
                        string = params.count > 1 && pluralisations.length > 1 ? pluralisations[1] : pluralisations[0];
                    else {
                        for(var i = 0; i < pluralisations.length; i++) {
                            var cur = pluralisations[i];
                            if(params.count === cur.min) {
                            // Catch cases of `{3} Translation for specific number`
                                string = cur.string;
                                break;
                            } else if(params.count >= cur.min && params.count <= cur.max) {
                            // Catch cases of `[1,19] Translation for range`
                                string = cur.string;
                                break;
                            }
                        }
                    }
                }
                // Now replace all other params
                if(params) {
                    _.chain(params).keys().forEach(function(key) {
                        var safe = $sanitize(params[key]);
                        if(safe.indexOf('$') >= 0)
                            safe = safe.replace(/\$/g, '$$$$');
                        string = string.replace(new RegExp(':' + key, 'g'), safe);
                    }).value();
                }
                return string;
            }
        };
    }).name;
